import { AppLayout } from "@/components/AppLayout";
import { PageHeader } from "@/components/ui/page-header";

export default function TermsOfService() {
  return (
    <AppLayout>
      <PageHeader 
        title="Terms of Service" 
        description="Legal terms and conditions for using TailorWiz"
        backTo="/"
      />
      <div className="container mx-auto max-w-4xl px-4 py-12">
        <div className="prose prose-lg max-w-none dark:prose-invert">
          <p className="text-muted-foreground text-center mb-12">
            <strong>Effective Date:</strong> August 19, 2025
          </p>

          <div className="bg-card p-6 rounded-lg border mb-8">
            <p className="text-lg leading-relaxed">
              By accessing or using TailorWiz, you agree to the following terms:
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-primary">1. Our Services</h2>
            <p className="text-base leading-relaxed">
              TailorWiz provides online tools that allow you to tailor resumes, analyze job matches, determine your qualifications for a role, and manage your job search. We may add, remove, or update features at our discretion.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-primary">2. Your Responsibilities</h2>
            <ul className="space-y-2 list-disc pl-6">
              <li>Provide accurate information when creating an account or uploading documents</li>
              <li>Maintain the confidentiality of your account login credentials</li>
              <li>Use the platform only for lawful purposes related to your job search</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-primary">3. Payment & Billing</h2>
            <p className="text-base leading-relaxed">
              All paid plans are billed in advance. Refunds are only issued where required by law or in the case of a proven technical failure on our part.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-primary">4. Limitation of Liability</h2>
            <div className="bg-muted p-6 rounded-lg border">
              <p className="text-base leading-relaxed">
                TailorWiz does not guarantee job interviews or employment. Our tools are designed to improve your job application materials, not to replace your own effort and judgment in your career search.
              </p>
            </div>
          </section>
        </div>
      </div>
    </AppLayout>
  );
}